module.exports = [{"type":"title","text":"2024-09-11"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Coin-M: Get K-line Data interface, add a note stating that only data from the last 30 days can be queried."},{"type":"html","text":"new: agent api"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-09-11.json
// module id = Lezn
// module chunks = 3